import { Text } from 'hb-react/shared/components/formik/components/inputs';

export const Duration = () => (
  <Text
    id="duration"
    label={s__('JobForm|Duration')}
    name="duration"
    placeholder={s__('JobForm|Duration of the opportunity')}
  />
);
